import { AdvertisingResearchFilters } from './widgets/advertising-research-filters/AdvertisingResearchFilters'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { Competitors } from './widgets/competitors/Competitors'
import { Keywords } from './widgets/keywords/Keywords'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectProject,
  selectResearchActiveTab,
  setResearchActiveTab,
  TResearchTabs,
} from './model/researchSlice'
import { useTranslation } from 'react-i18next'
import { PreparingDataStub } from '../../lib/widgets/stubs/PreparingDataStub'
import { StubLayout } from '../../lib/widgets/stubs/StubLayout'
import clsx from 'clsx'

import styles from './AdvertisingResearchPage.module.scss'
import { CommonMainPage } from '../../widgets/utility/CommonMainPage'

export const AdvertisingResearchPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const activeTab = useAppSelector(selectResearchActiveTab)
  const { has_paid_links: hasPaidLinks } = useAppSelector(selectProject)

  return (
    <CommonMainPage title={t('navigation.advertisingResearch')}>
      <AdvertisingResearchFilters />
      {hasPaidLinks ? (
        <>
          <BpTabs
            active={activeTab}
            className={clsx(styles.tabs)}
            size={'md'}
            onToggle={(e) => dispatch(setResearchActiveTab(e as TResearchTabs))}
          >
            <BpTab title={t('pages.advertisingResearch.advertisers')}>
              <Competitors />
            </BpTab>
            <BpTab title={t('pages.advertisingResearch.keywords')}>
              <Keywords />
            </BpTab>
          </BpTabs>
        </>
      ) : (
        <StubLayout>
          <PreparingDataStub />
        </StubLayout>
      )}
    </CommonMainPage>
  )
}
